import React from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** Two-colour array to cycle between, default day→dusk */
  colors?: string[];
  /** Full cycle duration seconds, default 8 */
  dur?: number;
}

/**
 * TintShift — animated colour-grade overlay cycling between two tones
 * (e.g. day → dusk mood shift).
 */
const TintShift: React.FC<Props> = ({
  colors = ["rgba(255,190,120,0.25)", "rgba(120,150,255,0.25)"],
  dur = 8,
}) => (
  <div style={overlayBase}>
    <style>{`
      @keyframes oot-tint {
        0%   { opacity: 1; }
        50%  { opacity: 0; }
        100% { opacity: 1; }
      }
    `}</style>
    <div style={{ position: "absolute", inset: 0, background: colors[0] }} />
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: colors[1],
        animation: `oot-tint ${dur}s ease-in-out infinite`,
      }}
    />
  </div>
);

export default TintShift;
